export { default } from './ImageWithText.js'
export type { ImageWithTextProps } from './types.js'
export { Cols } from './types.js'
